import { RefreshCcw, X } from "lucide-react";

import { Button } from "@/components/ui/button";

interface PwaUpdateBannerProps {
  onDismiss: () => void;
  onReload: () => void;
}

export function PwaUpdateBanner({
  onDismiss,
  onReload,
}: PwaUpdateBannerProps) {
  return (
    <div className="fixed left-3 right-3 bottom-[calc(env(safe-area-inset-bottom,0px)+76px)] z-40 md:left-auto md:right-4 md:w-[360px]">
      <div
        className="rounded-2xl border px-4 py-4 shadow-2xl backdrop-blur-md"
        style={{
          background:
            "linear-gradient(135deg, color-mix(in srgb, var(--accent-primary) 92%, black 8%), color-mix(in srgb, var(--accent-primary) 78%, black 22%))",
          borderColor: "color-mix(in srgb, var(--accent-primary) 55%, white 15%)",
        }}
      >
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-white/14 text-white">
            <RefreshCcw className="h-4 w-4" />
          </div>

          <div className="min-w-0 flex-1">
            <p className="text-xxs font-semibold uppercase tracking-[0.18em] text-white/75">
              Update Ready
            </p>
            <p className="mt-1 text-sm font-semibold text-white">
              A new version of LYTICK is available.
            </p>
            <p className="mt-1 text-xs leading-5 text-white/80">
              Reload to switch to the latest workspace assets and service worker.
            </p>
          </div>

          <button
            type="button"
            onClick={onDismiss}
            className="rounded-full p-1.5 text-white/75 transition hover:bg-white/10 hover:text-white"
            aria-label="Dismiss update banner"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="mt-4 flex items-center justify-end gap-2">
          <Button
            variant="ghost"
            className="h-9 rounded-full px-4 text-xs text-white hover:bg-white/10 hover:text-white"
            onClick={onDismiss}
          >
            Later
          </Button>
          <Button
            className="h-9 rounded-full bg-white px-4 text-xs font-semibold text-[var(--bg-base)] hover:bg-white/90"
            onClick={onReload}
          >
            Reload
          </Button>
        </div>
      </div>
    </div>
  );
}
